import { AirtablePermissions } from "@/types/crm/airtable/common";

export const airtableRequiredPermissions: AirtablePermissions[] = ["create"];
